import { render, staticRenderFns } from "./TableBIR.vue?vue&type=template&id=4a10f56b&scoped=true"
import script from "./TableBIR.vue?vue&type=script&lang=js"
export * from "./TableBIR.vue?vue&type=script&lang=js"
import style0 from "./TableBIR.vue?vue&type=style&index=0&id=4a10f56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10f56b",
  null
  
)

export default component.exports